import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  clientIncetive: null,
  chargeCancellationCosts: null,
  kpiApply: null,
  additionalConditionsInContract: null,
  entries: [],
};
